const createMemoryStorage = () => {
  let store = {};
  return {
    getItem: (key) => (key in store ? store[key] : null),
    setItem: (key, value) => {
      store[key] = value;
    },
    removeItem: (key) => {
      delete store[key];
    },
  };
};

const memoryStorage = createMemoryStorage();

export const getSessionStorageSafe = () => {
  if (typeof window === 'undefined') return memoryStorage;
  try {
    return window.sessionStorage;
  } catch (error) {
    console.warn('Falling back to memory storage for session data', error);
    return memoryStorage;
  }
};

export const createSessionPersistor = (key, defaultValue) => {
  const storage = getSessionStorageSafe();

  const load = () => {
    try {
      const raw = storage.getItem(key);
      if (!raw) return defaultValue;
      return { ...defaultValue, ...JSON.parse(raw) };
    } catch (error) {
      console.warn(`Failed to load session key "${key}"`, error);
      return defaultValue;
    }
  };

  const save = (value) => {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn(`Failed to persist session key "${key}"`, error);
    }
  };

  const clear = () => {
    try {
      storage.removeItem(key);
    } catch (error) {
      console.warn(`Failed to clear session key "${key}"`, error);
    }
  };

  return { load, save, clear };
};

